import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

//REST-API
//local
// export const REST_URI = "http://localhost:8080";
//dev
// export const REST_URI = "https://gcp-poc-with-apollo-1081525845464.asia-south1.run.app";
//prod
export const REST_URI = "https://prod-tks-1081525845464.asia-south1.run.app";


//RAZORPAY-KEY
//dev
// export const RAZORPAY_KEY = "rzp_test_R1E4A2whW7RqSn";
//prod
export const RAZORPAY_KEY = "rzp_live_lhpcAL8o4iO0Yz";


//GRAPHQL
const client = new ApolloClient({
  link: new HttpLink({
    //local
    // uri: "http://localhost:8080/graphql",
    //dev
    // uri:'https://gcp-poc-with-apollo-1081525845464.asia-south1.run.app/graphql',
    //prod
    uri:'https://prod-tks-1081525845464.asia-south1.run.app/graphql'
  }),
  cache: new InMemoryCache(),
});

export default client;
